import { CommonActions } from '@react-navigation/native';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';

export const navigationResetTo = (navigation: any, route: ROUTE_NAMES, params?: Record<string, any>) => {
  navigation.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [
        {
          name: route,
          params,
        },
      ],
    }),
  );
};

export const navigateTo = (navigation: any, route: ROUTE_NAMES, params?: Record<string, any>) => {
  navigation.push(route, { ...params });
};
